import changeCase from 'Common/Utils/changeCase';

export default (text: string) =>
  changeCase(text, { capitalise: true, lowercase: false });
